import { useState } from "react";
import { Link } from "react-router-dom";
import MovieGrid from "@/components/feature/MovieGrid";
import Modal from "@/components/base/Modal";
import SectionHeading from "@/components/feature/SectionHeading";
import { useFavorites } from "@/hooks/useFavorites";
import { useSeo } from "@/hooks/useSeo";
import { getMoviesByIds } from "@/lib/movies";

export default function Favorites() {
  const { favorites, clearFavorites } = useFavorites();
  const [confirmOpen, setConfirmOpen] = useState(false);

  useSeo({
    title: "我的收藏 - 91免费看片",
    description:
      "查看你在91免费看片收藏的影视内容，随时回到想看的高清电影、电视剧、综艺与动漫，收藏保存在本地浏览器中。",
    keywords: "我的收藏,影视收藏,91免费看片",
  });

  const list = getMoviesByIds(favorites);

  return (
    <div className="mx-auto w-full max-w-[1280px] px-4 py-6 md:px-6 md:py-8">
      <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
        <SectionHeading
          title="我的收藏"
          subtitle="收藏内容保存在本地浏览器，刷新后依然保留"
          icon="ri-heart-3-line"
        />
        {favorites.length > 0 && (
          <button
            type="button"
            onClick={() => setConfirmOpen(true)}
            className="flex w-fit cursor-pointer items-center gap-1 whitespace-nowrap rounded-md border border-background-300 px-4 py-2 text-sm font-medium text-foreground-600 transition-colors hover:border-accent-400 hover:text-accent-600"
          >
            <i className="ri-delete-bin-6-line" /> 清空收藏
          </button>
        )}
      </div>

      {favorites.length > 0 ? (
        <>
          <p className="mb-5 text-sm text-foreground-500">
            已收藏 <span className="font-semibold text-accent-600">{favorites.length}</span> 部影视作品
          </p>
          <MovieGrid movies={list} />
        </>
      ) : (
        <div className="flex flex-col items-center justify-center rounded-xl border border-dashed border-background-300 bg-background-50 py-20 text-center">
          <span className="flex h-16 w-16 items-center justify-center rounded-full bg-background-100 text-foreground-400">
            <i className="ri-heart-3-line text-3xl" />
          </span>
          <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">
            还没有收藏任何影视
          </h3>
          <p className="mt-2 max-w-md text-sm text-foreground-500">
            在影视卡片或详情页点击爱心即可加入收藏，方便下次快速找到想看的内容。
          </p>
          <div className="mt-6 flex flex-wrap justify-center gap-3">
            <Link
              to="/category/电影"
              className="rounded-md bg-primary-600 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-700"
            >
              去发现电影
            </Link>
            <Link
              to="/special"
              className="rounded-md border border-background-300 px-5 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:border-accent-400 hover:text-accent-600"
            >
              浏览专题
            </Link>
          </div>
        </div>
      )}

      <Modal
        open={confirmOpen}
        title="确认清空收藏"
        icon="ri-error-warning-line"
        onClose={() => setConfirmOpen(false)}
      >
        <p className="text-sm leading-relaxed text-foreground-700">
          确定要清空全部 {favorites.length} 条收藏吗？此操作不可撤销。
        </p>
        <div className="mt-5 flex justify-end gap-3">
          <button
            type="button"
            onClick={() => setConfirmOpen(false)}
            className="whitespace-nowrap rounded-md border border-background-300 px-4 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-background-100"
          >
            取消
          </button>
          <button
            type="button"
            onClick={() => {
              clearFavorites();
              setConfirmOpen(false);
            }}
            className="whitespace-nowrap rounded-md bg-accent-500 px-4 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-accent-600"
          >
            确认清空
          </button>
        </div>
      </Modal>
    </div>
  );
}